import { ref } from 'vue'

// Module-level singleton — shared across all components
const state = ref(null)

export function useConfirm() {
  /**
   * Show a confirmation dialog. Returns a Promise<boolean>.
   */
  const confirm = (opts) =>
    new Promise((resolve) => {
      state.value = {
        title:       opts.title       || 'Are you sure?',
        message:     opts.message     || '',
        confirmText: opts.confirmText || 'Confirm',
        cancelText:  opts.cancelText  || 'Cancel',
        danger:      opts.danger      ?? false,
        isAlert:     false,
        resolve,
      }
    })

  /**
   * Show an error/warning alert (no cancel, just dismiss). Returns a Promise<void>.
   * @param {Object} opts
   * @param {string} opts.title
   * @param {string} [opts.message]   — main explanation
   * @param {string} [opts.hint]      — extra tip shown in a highlighted box
   * @param {string} [opts.confirmText]
   */
  const alert = (opts) =>
    new Promise((resolve) => {
      state.value = {
        title:       opts.title       || 'Error',
        message:     opts.message     || '',
        hint:        opts.hint        || '',
        confirmText: opts.confirmText || 'Got it',
        cancelText:  null,
        danger:      false,
        isAlert:     true,
        resolve,
      }
    })

  const close = (result) => {
    state.value?.resolve(result)
    state.value = null
  }

  return { confirmState: state, confirm, alert, close }
}
